import { Shield, Lock, FileX } from 'lucide-react';

export default function PrivacyBadge({ compact = false }) {
  if (compact) {
    return (
      <div
        data-testid="lite-privacy-badge-compact"
        className="inline-flex items-center gap-2 text-xs text-stone-500"
      >
        <Shield className="w-3.5 h-3.5 text-emerald-600" />
        <span>No storage · Not linked to you · Export only</span>
      </div>
    );
  }
  return (
    <div
      data-testid="lite-privacy-badge"
      className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-stone-600"
    >
      <div className="flex items-center gap-2">
        <FileX className="w-4 h-4 text-emerald-600" />
        <span>No data stored</span>
      </div>
      <div className="flex items-center gap-2">
        <Lock className="w-4 h-4 text-emerald-600" />
        <span>Not linked to you</span>
      </div>
      <div className="flex items-center gap-2">
        <Shield className="w-4 h-4 text-emerald-600" />
        <span>Export only</span>
      </div>
    </div>
  );
}
